import { IsEmpty, IsValidEmail } from "../../utils/helper";

export default function IsValidCustomOrgChartData(data, isAdding) {
  let errors = {};
  const nameRegex = /^[A-Za-z\s'-]+$/;

  if (isAdding) {
    if (IsEmpty(data.email)) {
      errors.email = "Please select a member.";
    }
  } else {
    if (IsEmpty(data.first_name)) {
      errors.first_name = "First name is required.";
    } else {
      const trimmedFirstName = data.first_name.trim();
      if (trimmedFirstName.length < 3 || trimmedFirstName.length > 30) {
        errors.first_name = "First name must be between 3 and 30 characters";
      } else if (!nameRegex.test(trimmedFirstName)) {
        errors.first_name = "First name must only contain letters";
      }
    }

    if (IsEmpty(data.last_name)) {
      errors.last_name = "Last name is required.";
    } else {
      const trimmedLastName = data.last_name.trim();
      if (trimmedLastName.length < 3 || trimmedLastName.length > 30) {
        errors.last_name = "Last name must be between 3 and 30 characters";
      } else if (!nameRegex.test(trimmedLastName)) {
        errors.last_name = "Last name must only contain letters";
      }
    }

    if (IsEmpty(data.email)) {
      errors.email = "Email is required.";
    } else if (!IsValidEmail(data.email)) {
      errors.email = "Invalid Email!";
    }
  }

  if (!data.isRoot || isAdding) {
    if (IsEmpty(data.department)) {
      errors.department = "Department is required.";
    } else {
      const trimmedDepartment = data.department.trim();
      if (trimmedDepartment.length < 3 || trimmedDepartment.length > 30) {
        errors.department = "Department must be between 3 and 30 characters";
      } else if (!nameRegex.test(trimmedDepartment)) {
        errors.department = "Department must only contain letters";
      }
    }

    if (IsEmpty(data.role)) {
      errors.role = "Role is required.";
    } else {
      const trimmedRole = data.role.trim();
      if (trimmedRole.length < 3 || trimmedRole.length > 30) {
        errors.role = "Role must be between 3 and 30 characters";
      } else if (!nameRegex.test(trimmedRole)) {
        errors.role = "Role must only contain letters";
      }
    }
  }

  return {
    isValid: IsEmpty(errors),
    errors: errors,
  };
}